import produce from 'immer'

import { FETCH_ALIASES, FETCH_ALIASES_SUCCESS, FETCH_ALIASES_FAILURE } from '../actions/types'

export const initialAliasState = {
  id: null,
  index: null,
  name: null,
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_ALIASES: {
      draft.fetching = true
      break
    }
    case FETCH_ALIASES_SUCCESS: {
      const aliases = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Reset all aliases
      draft.byId = {}
      draft.allIds = []

      // Add all aliases to state
      for (const alias of aliases) {
        const id = alias.name
        if (draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...alias,
          id,
        }
      }

      break
    }
    case FETCH_ALIASES_FAILURE: {
      const error = payload

      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }

    default:
      // Nothing to do
      break
  }
}, initialState)
